import { request } from '@/utils/request';

const urls = {
  budgetQuotaList: '/zlb/budget/quota/list', // 预算额度列表
  economyClassifyList: '/zlb/budget/manage/query-economy-classify', // 查询经济分类
  statisticsAmountinfo: '/zlb/budget/info/statistics-amount', // 查询统计指标金额
  saveBudgetQuota: '/zlb/budget/quota/save', // 生成预算额度
  getBudgetQuota: '/zlb/budget/quota/detail', // 查询预算额度详情
  deleteBudgetQuota: '/zlb/budget/quota/delete', // 删除预算额度
  getBudgtUsedRecord: '/zlb/budget/manage/query-budget-used-record', // 查询预算使用记录
  getProjectList: '/zlb/budget/manage/query-project', // 查询预算项目
  transferredQuota: '/zlb/budget/quota/carry-over-quota', // 结转预算额度
};

// 查询预算额度列表
export async function fetchBudgetQuotaList(data) {
  return request(urls.budgetQuotaList, { method: 'POST', data });
}

// 查询经济分类列表
export async function fetchEconomyClassifyList(data) {
  return request(urls.economyClassifyList, { method: 'POST', data });
}

// 查询统计指标金额
export async function fetchStatisticsAmountinfo(data) {
  return request(urls.statisticsAmountinfo, { method: 'POST', data });
}

export async function saveBudgetQuota(data) {
  return request(urls.saveBudgetQuota, { method: 'POST', data });
}

export async function deleteBudgetQuota(data) {
  return request(urls.deleteBudgetQuota, { method: 'POST', data });
}

export async function getBudgetQuota(params) {
  return request(`${urls.getBudgetQuota}/${params.quotaId}`);
}

// 查询经济分类列表
export async function getBudgtUsedRecord(data) {
  return request(urls.getBudgtUsedRecord, { method: 'POST', data });
}

// 查询预算项目
export async function getProjectList(data) {
  return request(urls.getProjectList);
}
// 结转预算额度

export async function transferredQuota(data) {
  return request(urls.transferredQuota, { method: 'POST', data });
}
